import { render, staticRenderFns } from "./ResultIndex.vue?vue&type=template&id=27c809f2&"
import script from "./ResultIndex.vue?vue&type=script&lang=js&"
export * from "./ResultIndex.vue?vue&type=script&lang=js&"
import style0 from "./ResultIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports